import React, { useEffect, useState } from 'react';
import TextBox from '../bprmFormControllers/TextBox';
import Label from '../bprmFormControllers/Label';
import Dropdown from '../bprmFormControllers/Dropdown';
import Multiline from '../bprmFormControllers/Multiline';
import Date from '../bprmFormControllers/Date';
import Button from '../bprmFormControllers/Button';
import Radio from '../bprmFormControllers/Radio';
import CheckBox from '../bprmFormControllers/CheckBox';
import FileUpload from '../bprmFormControllers/FileUpload';
import { allStateCountyCityReceived, executeBprmFormRule, getDataTypeCodemanager, getStateCountyCity, getTaskFormSavedStatus, saveBprmForm, taskFormSaved } from '../../store/bprmForm';
import Joi from 'joi-browser';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import geoService, { getGeoCountyData, getGeoStateData } from '../../services/geoService';
import { getApplicationData, getDropdownCodemanager } from '../../services/appService';
import { getAppDefaultData, getApplication, getTaskDoneStatus, loadAppDefaultData, loadApplication, taskDone, wfTaskDone } from '../../store/wfApp';
import Notification from '../common/Notification';

const WorkflowElement = (props) => {
    const { formtype, wfTask, handleNextTask, appSummary,
        viewType, codeVerified, updatedStateData,
        wfTaskType, saveBtnProcessStatus,
        setSaveBtnProcessStatus,
        workflowFormData, documentInfo, actionType,
        wfForm, subFormObj, subFormDocs, handleCloseButton, clientId } = props;

    const [stateSchema, setStateSchema] = useState({});
    const [stateData, setStateData] = useState({});
    const [stateErrors, setStateErrors] = useState({});
    const [codeIsVerified, setCodeIsVerified] = useState(true);
    const [isDisabled, setIsDisabled] = useState(false);
    const [encryptionDecryptions, setEncryptionDecryptions] = useState({});
    const [stateCountyCity, setStateCountyCity] = useState([]);
    const [ddTypeCodMngr, setDdTypeCodMngr] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [subformDataType, setSubformDataType] = useState([])
    const [elements, setElements] = useState([]);
    const [currentInputType, setCurrentInputType] = useState("");

    const [aWorkfinityAppEntity, setAworkfinityAppEntity] = useState("");
    const [aWorkfinityApp, setAworkfinityApp] = useState("");


    const [allCountryList, SetAllCountryList] = useState([]);
    const [allStateList, setAllStateList] = useState([]);
    const [allCountyList, setAllCountyList] = useState([]);
    const [isCountryStateChanged, setIsCountryStateChanged] = useState(true);

    const [btnProcessStatus, setBtnProcessStatus] = useState(saveBtnProcessStatus);
    const [currentButtonMessage, setCurrentButtonMessage] = useState("");
    const [currentButtonType, setCurrentButtonType] = useState("");

    const [isTaskForm, setIsTaskForm] = useState(false);

    const [notify, setNotify] = useState({ isOpen: false, message: "", type: "", });

    const appDefaultDataSelector = useSelector(getAppDefaultData);
    const applicationSelector = useSelector(getApplication);

    const taskFormSavedStatusSelector = useSelector(getTaskFormSavedStatus);
    const taskDoneStatusSelector = useSelector(getTaskDoneStatus);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!saveBtnProcessStatus) {
            setBtnProcessStatus(false);
            if (setSaveBtnProcessStatus)
                setSaveBtnProcessStatus(null);
        }
    }, [saveBtnProcessStatus])

    useEffect(() => {
        console.log("wfTask", wfTask);
        if (wfTask?.ciid > 0)
            dispatch(loadApplication(wfTask?.ciid, clientId));

        if (viewType) {
            setIsDisabled(true);
            setCodeIsVerified(false);
        }
        else {
            //setIsDisabled(false);
            setCodeIsVerified(true);
        }
    }, [wfTask]);

    useEffect(() => {
        if (codeVerified) setCodeIsVerified(true);
    }, [codeVerified]);

    useEffect(() => {
        console.log("applicationSelector", applicationSelector);
        if (applicationSelector) {
            const latestApp = applicationSelector;//[applicationSelector.length - 1];

            console.log("latestApp", latestApp);

            if (latestApp.applicationData !== "") {
                const obj = getApplicationData(latestApp.applicationData);

                if (obj?.aWorkfinityApp)
                    setAworkfinityApp(obj.aWorkfinityApp);

                if (obj?.aWorkfinityAppEntity)
                    setAworkfinityAppEntity(obj?.aWorkfinityAppEntity);

                if (workflowFormData && obj?.data) {
                    const newData = { ...obj.data, ...workflowFormData };
                    setStateData(newData);

                } else if (obj?.data) {
                    setStateData(obj.data);
                }
            }
            else {
                dispatch(loadAppDefaultData(latestApp.applicationId));
            }
        } else {
            setAworkfinityApp("");
            setAworkfinityAppEntity("");
            setStateData({});
        }
    }, [applicationSelector]);

    useEffect(() => {
        if (appDefaultDataSelector) {
            const obj = getApplicationData(JSON.stringify(appDefaultDataSelector));
            if (obj?.aWorkfinityApp) {
                setAworkfinityApp(obj.aWorkfinityApp);
            }
            if (obj?.aWorkfinityAppEntity) {
                setAworkfinityAppEntity(obj?.aWorkfinityAppEntity);
            }
        }
    }, [appDefaultDataSelector])

    useEffect(() => {
        if (wfForm && wfForm !== "") {
            setBtnProcessStatus(false);
            setDocuments([]);

            if (wfForm.isEdit !== null && !wfForm.isEdit && wfTaskType !== "viewForm" || wfTask?.taskDoneStatus === 4) {
                //setIsDisabled(true)
            };

            if (wfForm?.elementJson)
                setElements(JSON.parse(wfForm?.elementJson));

        } else {
            setElements([]);
        }

    }, [wfForm])

    useEffect(() => {
        if (wfForm) {
            if (currentInputType !== "textbox" && currentInputType !== "textarea") {
                loadStateCounty();
                loadDDType();
            }
        }
    }, [stateData]);

    const loadStateCounty = async () => {
        const addResult = await getStateCountyCity(wfForm, stateData);
        const presult = await Promise.all(Object.keys(addResult).map(async (x) => {
            const obj = addResult[x];
            if (obj) {
                const nObj = await Promise.all(obj?.stateObjects.map(async (s) => {
                    const nX = { ...s }
                    const rs = getGeoStateData(s.id);
                    nX.list = rs;
                    return nX;
                }));

                obj.stateObjects = nObj;

                const cObj = await Promise.all(obj?.countyObjects.map(async (s) => {
                    let csobj = null;
                    nObj.map(st => {
                        st.list.forEach(sm => {
                            if (sm.name === s.name) {
                                csobj = sm;
                                return;
                            }
                        })
                        return;
                    });
                    const nX = { ...s }
                    let rs = [];
                    if (csobj) {
                        rs = await getGeoCountyData(csobj.geonameId);
                    }
                    nX.list = rs;
                    return nX;
                }));

                obj.countyObjects = cObj;
            }
            return obj;
        }));
        dispatch(allStateCountyCityReceived(presult));
    }

    const loadDDType = async () => {
        const ddResult = await getDataTypeCodemanager(wfForm);
        if (ddResult?.ddTypeCodMngr.length > 0) {
            const result = await Promise.all(ddResult.ddTypeCodMngr.map(async (code) => {
                if (!code?.dataType) return;
                const ddItems = await getDropdownCodemanager(code.dataType, code.attribute);
                let childId = "";
                if (code.childDataType)
                    childId = code.childDataType.toLowerCase();
                if (code.childAttribute)
                    childId += "." + code.childAttribute;

                const ddTypeObj = {
                    controlId: code.dataType.toLowerCase() + "." + code.attribute,
                    optionData: ddItems,
                    allOptionData: ddItems,
                    childControlId: childId
                };
                return ddTypeObj;
            }));

            let updResult = [...result];
            result.map(dd => {
                if (dd.childControlId) {
                    const childObj = updResult.filter(x => x.controlId === dd.childControlId);
                    if (childObj.length > 0) {
                        const pData = stateData[dd.controlId];
                        if (pData) {
                            const pObj = dd?.allOptionData.filter(x => x.name === pData);
                            if (pObj) {
                                if (childObj.length > 0) {
                                    const childOptions = childObj[0].allOptionData.filter(x => x.parentCode === pObj[0].code);
                                    childObj[0].optionData = childOptions;
                                }
                            }
                            else {
                                childObj[0].optionData = [];
                            }
                        }
                        else {
                            childObj[0].optionData = [];
                        }
                    }

                    const index = updResult.findIndex(x => x.controlId === dd.childControlId);
                    updResult[index] = childObj[0];
                }
            })
            setDdTypeCodMngr(updResult);
        }

        if (ddResult.subformDataType.length > 0) {
            // const result = await Promise.all(ddResult.subformDataType.map(async (sub) => {
            //     const subDdItems = await getSubformDatatypes(sub.dataType, sub.attribute);
            //     return subDdItems;
            // }));
            setSubformDataType(ddResult.subformDataType);
        }
    }

    const handleChange = (input) => {
        const data = { ...stateData };
        const errors = { ...stateErrors };
        const errorMessage = validateProperty(input);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];
        data[input.name] = input.value;
        setStateData(data);
        setStateErrors(errors);
    };

    const validateProperty = ({ name, value }) => {
        if (stateSchema[name] != undefined) {
            const obj = { [name]: value };
            const schema = { [name]: stateSchema[name] };
            const { error } = Joi.validate(obj, schema);
            return error ? error.details[0].message : null;
        } else {
            return null;
        }
    };

    const handeOnChange = ({ target: input }) => {
        handleChange(input);
        if (input.dataset?.encryption) {
            addEncryptionFieldData(input.name, input.value);
        }
    };

    const addEncryptionFieldData = (name, value) => {
        const encryp = { ...encryptionDecryptions };
        const data = { ...stateData }
        const newValue = value.replace(/\-/g, "");

        let modifiedValue = "";
        for (let i = 0; i < newValue.length; i++) {
            modifiedValue += "*";
        }
        if (encryp[name + "encrypt"]) {
            data[name] = modifiedValue;
            encryp[name] = encryp[name] + value.replace(/[^\d]/g, "");
        } else {
            data[name] = value.replace(/[^\d]/g, "");
            encryp[name] = modifiedValue;
        }
        setEncryptionDecryptions(encryp);
        setStateData(data);
    };

    const handleEncryptionDecryption = (name) => {
        const updatedData = { ...stateData };
        const encryp = { ...encryptionDecryptions };
        if (encryp[name + "encrypt"]) {
            const actualValue = encryp[name];
            const encryptedValue = updatedData[name];
            encryp[name] = encryptedValue;
            updatedData[name] = actualValue;
            encryp[name + "encrypt"] = false;
        } else {
            const encryptedValue = encryp[name];
            const actualValue = updatedData[name];
            encryp[name] = actualValue;
            updatedData[name] = encryptedValue;
            encryp[name + "encrypt"] = true;
        }
        setEncryptionDecryptions(encryp);
        setStateData(updatedData);
    };

    const getEvaluatedValue = async (comp) => {
        const ruleId = comp.rule;
        const data = { ...stateData };
        Object.keys(data).forEach(function (keyValue) {
            const dd = keyValue.split(".");
            if (dd.length > 1) {
                if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                    if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                        var item = data[keyValue];
                        if (Array.isArray(item))
                            aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                        else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                    }
            }
        });
        const appShortName = Object.keys(aWorkfinityApp)[1];
        aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
        const formData = new FormData();
        formData.append("appEntity", JSON.stringify(aWorkfinityApp));
        formData.append("appId", 1);
        formData.append("ruleId", ruleId);
        dispatch(executeBprmFormRule(formData));
    };

    const onFileChange = async (event) => {
        const docs = [...documents];
        const data = { ...stateData };
        const fupt = event.target?.dataset?.datatype;
        const ft = event.target?.dataset?.attdatatype;
        const allFiles = event.target.files;
        if (allFiles.length === 0) return;
        const evName = event.target.name;
        const evId = event.target?.id;
        // if (ft === "geotag" && allFiles.length > 0) {
        //     const geoData = await exifr.gps(allFiles[0]);
        //     if (!geoData) {
        //         getAlert("", "Geo Data Not Found", "error");
        //         return;
        //     }
        //     geoLoc = JSON.stringify(geoData);
        //     data[evName] = geoLoc;
        // }
        const docIndex = docs.findIndex((x) => x.refId === evName);
        if (docIndex > -1 && fupt !== "multiple") {
            docs.splice(docIndex, 1);
        }
        let indx = 0;
        if (docs.length > 0) {
            indx = docs[docs.length - 1].id;
        }

        for (const file of allFiles) {
            indx += 1;
            const ext = file.name.split(".");
            var doc = {
                id: indx,
                name: file.name,
                newName: file.name,
                type: file.type,
                file: file,
                compId: evId,
                refId: evName,
                extension: ext.length > 1 ? ext[1] : "",
            };

            if (ft === "geotag")
                doc.refId = ft;

            docs.push(doc);
        }

        data[evName] = allFiles[0].name;

        // let fieldName = "";
        // let comma = "";
        // if (docs.length > 1) {
        //     docs.map(d => { fieldName += comma + d.name; comma = ", "; });
        //     data[evName] = fieldName;
        // }
        //console.log("docs", docs);
        validateDocuments(docs);
        setDocuments(docs);
        setStateData(data);
    };

    const validateDocuments = (docs) => {
        const errors = { ...stateErrors };
        const data = { ...stateData };
        if (docs.length > 0) {
            data["docs"] = docs.length.toString();
            delete errors["docs"];
        } else {
            const obj = { schedule: "" };
            const schema = { schedule: stateSchema["docs"] };
            const { error } = Joi.validate(obj, schema);
            errors["docs"] = error.details[0].message;
            data["docs"] = "";
        }
        setStateData(data);
        setStateErrors(errors);
    };

    const validate = () => {
        if (wfTask?.status) return true;
        const options = { abortEarly: false, allowUnknown: true };
        const result = Joi.validate(stateData, stateSchema, options);
        if (!result.error) return null;
        const errors = {};
        for (let item of result.error.details) errors[item.path[0]] = item.message;
        return errors;
    };

    const doSubmit = (btn, alMsg) => {
        const btnType = btn.name;
        setCurrentButtonMessage(alMsg);
        setBtnProcessStatus(true);
        setCurrentButtonType(btnType);
        if (wfTaskType === "form") {
            setBtnProcessStatus(true);
            handleNextTask(stateData, btnType);
        }
        else {
            Object.keys(stateData).forEach(function (keyValue) {
                const dd = keyValue.split(".");
                if (dd.length > 1) {
                    if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                        if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                            var item = stateData[keyValue];
                            if (Array.isArray(item))
                                aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                            else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                        }
                }
            });

            const appShortName = Object.keys(aWorkfinityApp)[1];
            aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
            const frmData = new FormData();
            frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
            frmData.append("workItem", JSON.stringify(wfTask));
            frmData.append("upDocs", JSON.stringify(documents));
            frmData.append("clientId", clientId ? clientId : 0);
            documents.map((file, key) =>
                frmData.append("files[" + key + "]", file.file)
            );

            if (documentInfo) {
                frmData.append("docType", documentInfo.docType);
                frmData.append("updType", documentInfo.updType);
                frmData.append("message", documentInfo.message);
            }

            dispatch(saveBprmForm(frmData));

            if (wfTaskType === "viewForm") {
                setBtnProcessStatus(true);
                handleNextTask(frmData);
            }
            else if (btnType !== "save" && wfTask?.wiid > 0) {
                setBtnProcessStatus(true);
                setIsTaskForm(true);
            }
        }
    }

    useEffect(() => {
        console.log("taskFormSavedStatusSelector", taskFormSavedStatusSelector, isTaskForm);
        if (taskFormSavedStatusSelector && isTaskForm) {
            if (wfTask?.wiid > 0)
                dispatch(wfTaskDone(wfTask.wiid, clientId));

            dispatch(taskFormSaved(false));
            setIsTaskForm(false);
        }
        else if (taskFormSavedStatusSelector) {
            setIsTaskForm(false);
            dispatch(taskFormSaved(false))
            setBtnProcessStatus(false);
        }
        if (currentButtonMessage !== "") {
            //getAlert("", currentButtonMessage, "success");
            setNotify({
                isOpen: true,
                message: currentButtonMessage,
                type: "success",
            });
            setCurrentButtonMessage("");
            setCurrentButtonType("");
        }
    }, [taskFormSavedStatusSelector]);

    useEffect(() => {
        console.log("taskDoneStatusSelector", taskDoneStatusSelector);
        if (taskDoneStatusSelector) {
            dispatch(taskDone(false))
            if (currentButtonMessage !== "") {
                //getAlert("", currentButtonMessage, "success");
                setNotify({
                    isOpen: true,
                    message: currentButtonMessage,
                    type: "success",
                });
                setCurrentButtonMessage("");
                setCurrentButtonType("");
            }
            if (handleNextTask) handleNextTask(currentButtonType);
        }
    }, [taskDoneStatusSelector])

    const handleClose = () => {
        handleNextTask(currentButtonType);
    }

    return (
        <>
            <Grid container spacing={2}>
                {elements.map((col, index) => (
                    <Grid item xs={col.width} key={index} className={col.style}>
                        {col.components.map((comp, key) => {
                            let controleId = "";
                            if (comp.attributeType)
                                controleId = comp.attributeType?.toLowerCase();

                            if (comp.attributeObject)
                                controleId += "." + comp.attributeObject;

                            if (comp.dataType === "label") {
                                return <Label comp={comp} controleId={controleId} stateData={stateData} />
                            }

                            if (comp.dataType === "textBox") {
                                return <TextBox
                                    comp={comp}
                                    controleId={controleId}
                                    stateData={stateData}
                                    stateErrors={stateErrors}
                                    stateSchema={stateSchema}
                                    codeIsVerified={codeIsVerified}
                                    isDisabled={isDisabled}
                                    handleChange={handleChange}
                                    handeOnChange={handeOnChange}
                                    getEvaluatedValue={getEvaluatedValue}
                                />
                            }

                            if (comp.dataType === "dropDown") {
                                return <Dropdown
                                    key={key}
                                    comp={comp}
                                    controleId={controleId}
                                    stateData={stateData}
                                    stateErrors={stateErrors}
                                    codeIsVerified={codeIsVerified}
                                    isDisabled={isDisabled}
                                    stateCountyCity={stateCountyCity}
                                    setStateCountyCity={setStateCountyCity}
                                    ddTypeCodMngr={ddTypeCodMngr}
                                    setDdTypeCodMngr={setDdTypeCodMngr}
                                    handleChange={handleChange}
                                    handeOnChange={handeOnChange}
                                    setIsCountryStateChanged={setIsCountryStateChanged}
                                />
                            }

                            if (comp.dataType === "multiLineBox") {
                                return <Multiline
                                    comp={comp}
                                    controleId={controleId}
                                    stateData={stateData}
                                    stateErrors={stateErrors}
                                    isDisabled={isDisabled}
                                    encryptionDecryptions={encryptionDecryptions}
                                    handeOnChange={handeOnChange}
                                    getEvaluatedValue={getEvaluatedValue}
                                    handleEncryptionDecryption={handleEncryptionDecryption}
                                />
                            }

                            if (comp.dataType === "date") {
                                return <Date
                                    comp={comp}
                                    controleId={controleId}
                                    stateData={stateData}
                                    stateErrors={stateErrors}
                                    codeIsVerified={codeIsVerified}
                                    isDisabled={isDisabled}
                                    handleChange={handleChange}
                                />
                            }

                            if (comp.dataType === "radio") {
                                return <Radio
                                    comp={comp}
                                    controleId={controleId}
                                    stateData={stateData}
                                    stateErrors={stateErrors}
                                    isDisabled={isDisabled}
                                    handeOnChange={handeOnChange}
                                />
                            }

                            if (comp.dataType === "file") {
                                return <FileUpload
                                    comp={comp}
                                    controleId={controleId}
                                    stateData={stateData}
                                    stateErrors={stateErrors}
                                    isDisabled={isDisabled}
                                    onFileChange={onFileChange}
                                />
                            }

                            if (comp.dataType === "checkBox") {
                                return <CheckBox
                                    comp={comp}
                                    controleId={controleId}
                                    stateData={stateData}
                                    stateErrors={stateErrors}
                                    isDisabled={isDisabled}
                                    handleChange={handleChange}
                                    ddTypeCodMngr={ddTypeCodMngr}
                                />
                            }

                            if (comp.dataType === "button") {
                                return <Button comp={comp}
                                    btnProcessStatus={btnProcessStatus}
                                    //setBtnProcessStatus={setBtnProcessStatus}
                                    isDisabled={isDisabled}
                                    setIsDisabled={setIsDisabled}
                                    validate={validate}
                                    doSubmit={doSubmit}
                                    isEdit={wfForm?.isEdit}
                                    handleClose={handleClose}
                                    size="btn-sm"
                                    currentButtonType={currentButtonType}
                                />
                            }
                        })}
                    </Grid>
                ))}
            </Grid>

            <Notification notify={notify} setNotify={setNotify} />
        </>
    );
}

export default WorkflowElement;